import LocaleContainer from '@/components/LocaleContainer';
import LegalContainer from '@/components/LegalContainer';
import RealTimeTrackingContainer from '@/components/rtt/RealTimeTrackingContainer';
import PostcodePage from '@/v2/components/pages/PostcodePage.vue';

const LandingContainer = () => import('@/components/LandingContainer');
const LegacyDesign = () => import('@/pages/index/LegacyDesign.vue');
const NewDesignLandingContainer = () =>
  import('@/v2/components/pages/LandingPage.vue');
const NewDesignRealTimeTrackingContainer = () =>
  import('@/v2/components/pages/RealTimeTrackingPage.vue');
const NewDesign = () => import('@/pages/index/NewDesign.vue');

const imprintPaths = [
  'impressum',
  'imprint',
  'impronta',
  'impresum',
  'felhasználási-szabályzat',
  'mentions-légales',
  'tisk',
  'nadruk',
  'aviso-legal',
  'bedrijfsinformatie',
  'juridische-informatie',
  'mențiuni-legale',
  'обележје',
  'odtlačok',
  'odtis',
  'юридическая-информация',
  'aftryk'
];

const legalPaths = [
  'adatkezelesi-tajekoztato',
  'soukromi',
  'privatnost',
  'datenschutz',
  'privacy',
  'confidentialite',
  'privacidad',
  'prywatność',
  'confidențialitate',
  'конфиденциальность',
  'приватност',
  'ochrana-osobných-údajov',
  'zasebnost'
];

const contactPaths = [
  'kontakt',
  'kontakty',
  'contact',
  'contatto',
  'kapcsolat',
  'contatti',
  'contacto',
  'контакт',
  'persoană-de-contact',
  'stik'
];

const accessibilityPaths = [
  'accesibilidad',
  'accesibilitate',
  'accessibility',
  'accessibilità',
  'accessibilité',
  'akadálymentességi',
  'barrierefreiheit',
  'dostopnost',
  'dostępność',
  'pristupačnost',
  'prístupnosť',
  'přístupnost',
  'tilgængelighed',
  'toegankelijkheid'
];

const routes = [
  {
    component: LegacyDesign,
    name: 'legacyLanding',
    path: '/',
    children: [
      {
        component: LocaleContainer,
        path: ':countryOrTenantId/:locale',
        name: 'localeContainer',
        props: true,
        children: [
          ...imprintPaths.map(path => ({
            component: LegalContainer,
            name: `imprint.${path}`,
            path
          })),
          ...legalPaths.map(path => ({
            component: LegalContainer,
            name: `privacy.${path}`,
            path
          })),
          ...contactPaths.map(path => ({
            component: LegalContainer,
            name: `contact.${path}`,
            path
          })),
          ...accessibilityPaths.map(path => ({
            component: LegalContainer,
            name: `accessibility.${path}`,
            path
          })),
          {
            component: LandingContainer,
            name: 'localeLandingContainer',
            path: ''
          },
          {
            component: RealTimeTrackingContainer,
            name: 'realTimeTracking',
            path: ':trackingId/:postcode?',
            props: true
          }
        ]
      },
      {
        component: LandingContainer,
        name: 'landingContainer', // adapt LandingContainer if you change name
        path: ''
      }
    ]
  },
  {
    component: NewDesign,
    name: 'previewLanding',
    path: '/preview',
    children: [
      {
        component: LocaleContainer,
        path: ':countryOrTenantId/:locale',
        name: 'previewLocaleLanding',
        props: true,
        children: [
          ...imprintPaths.map(path => ({
            component: LegalContainer,
            name: `preview.imprint.${path}`,
            path
          })),
          ...legalPaths.map(path => ({
            component: LegalContainer,
            name: `preview.privacy.${path}`,
            path
          })),
          ...contactPaths.map(path => ({
            component: LegalContainer,
            name: `preview.contact.${path}`,
            path
          })),
          {
            component: NewDesignLandingContainer,
            name: 'previewLocaleLandingContainer',
            path: ''
          },
          {
            component: PostcodePage,
            name: 'previewPostCodePage',
            path: ':trackingId/',
            props: true
          },
          {
            component: NewDesignRealTimeTrackingContainer,
            name: 'previewRealTimeTracking',
            path: ':trackingId/:postcode?',
            props: true
          }
        ]
      },
      {
        component: NewDesignLandingContainer,
        name: 'previewLandingContainer',
        path: ''
      }
    ]
  }
];

export default routes;
